import React from 'react';

interface PhotoMetadataProps {
  latitude: number;
  longitude: number;
  accuracy?: number;
  isGettingLocation?: boolean;
  locationError?: string | null;
}

export function PhotoMetadata({ 
  latitude, 
  longitude, 
  accuracy,
  isGettingLocation,
  locationError 
}: PhotoMetadataProps) {
  if (isGettingLocation) {
    return (
      <div className="text-sm text-yellow-600 dark:text-yellow-400 mt-2">
        Getting location data... Please wait.
      </div>
    );
  }

  if (locationError) {
    return (
      <div className="text-sm text-red-600 dark:text-red-400 mt-2">
        Location error: {locationError}
      </div>
    );
  }

  if (latitude === 0 && longitude === 0) {
    return (
      <div className="text-sm text-yellow-600 dark:text-yellow-400 mt-2">
        No location data available. Photos will be taken without GPS coordinates.
      </div>
    );
  }

  return (
    <div className="text-sm text-gray-500 dark:text-gray-400 mt-2">
      <p>GPS: {latitude.toFixed(6)}, {longitude.toFixed(6)}</p>
      {accuracy && (
        <p>Accuracy: ±{Math.round(accuracy)}m</p>
      )}
    </div>
  );
}